<ng-container *transloco="let t">
  <div class="flex flex-col gap-3">
    <!-- Content section -->
    <p>
      {{ t("app.organization-settings.invitations.deleteConfirmation") }}
    </p>

    <div class="p-3 border border-surface-200 dark:border-surface-700 bg-surface-50 dark:bg-surface-800 rounded">
      <div class="grid grid-cols-[35%_1fr] gap-y-2">
        <span class="font-medium">{{ t("app.organization-settings.invitations.email") }}:</span>
        <span>{{ invitation.emailAddress }}</span>

        <span class="font-medium">{{ t("app.organization-settings.invitations.role") }}:</span>
        <span><p-tag [severity]="roleSeverity" [value]="roleName" /></span>

        <span class="font-medium">{{ t("app.organization-settings.invitations.validUntil") }}:</span>
        <span>{{ invitation.expiresAt | ranDate }}</span>
      </div>
    </div>

    <!-- Footer section -->
    <div class="mt-3 pt-3 border-t border-surface-200 dark:border-surface-700">
      <div class="flex flex-row gap-3 justify-end w-full">
        <p-button
          [label]="t('app.common.cancel')"
          severity="secondary"
          (click)="ref.close()"
          [disabled]="loading"
        ></p-button>
        <p-button
          [label]="t('app.common.delete')"
          severity="danger"
          (click)="confirmDelete()"
          [disabled]="loading"
          [loading]="loading"
        />
      </div>
    </div>
  </div>
</ng-container>
